import React, { useEffect, useState } from "react";
import { Ticket } from "./types";
import "./Ticket.css";

interface Props {
    ticket: Ticket;
    eventId: number;
    onSave: (ticket: Ticket) => void;
    onCancel: () => void;
}

const TicketForm: React.FC<Props> = ({
    ticket,
    eventId,
    onSave,
    onCancel,
}) => {
    const [form, setForm] = useState<Ticket>({
        ...ticket,
        eventID: eventId,
    });

    useEffect(() => {
        setForm({
            ...ticket,
            eventID: eventId,
        });
    }, [ticket, eventId]);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        onSave({
            ...form,
            eventID: eventId,
        });
    };

    return (
        <div className="form-container">
            <form onSubmit={handleSubmit} className="ticket-form-grid">
                <div>
                    <label>Description</label>
                    <input
                        type="text"
                        value={form.ticketDescription}
                        onChange={(e) =>
                            setForm({
                                ...form,
                                ticketDescription: e.target.value,
                            })
                        }
                        required
                    />
                </div>

                <div>
                    <label>Start Time</label>
                    <input
                        type="datetime-local"
                        value={form.ticketTimeStart}
                        onChange={(e) =>
                            setForm({
                                ...form,
                                ticketTimeStart: e.target.value,
                            })
                        }
                        required
                    />
                </div>

                <div>
                    <label>End Time</label>
                    <input
                        type="datetime-local"
                        value={form.ticketTimeEnd}
                        onChange={(e) =>
                            setForm({
                                ...form,
                                ticketTimeEnd: e.target.value,
                            })
                        }
                        required
                    />
                </div>

                <div>
                    <label>
                        <input
                            type="checkbox"
                            checked={form.active}
                            onChange={(e) =>
                                setForm({
                                    ...form,
                                    active: e.target.checked,
                                })
                            }
                        />{" "}
                        Active
                    </label>
                </div>

                <div className="form-actions full-width">
                    <button
                        type="submit"
                        className="edit-btn"
                    >
                        Save
                    </button>

                    <button
                        type="button"
                        className="cancel-btn"
                        onClick={onCancel}
                    >
                        Cancel
                    </button>
                </div>
            </form>
        </div>
    );
};

export default TicketForm;